export default __webpack_public_path__ + "58324b979bd31e57c8aaab7ea4d9c853.png";